import { Box, Button, Card, Grid } from '@mui/material'
import React from 'react'
import { Linker } from 'src/Components/Ui/Linker'
import { useLocale } from 'src/locales/useLocale'

const baseUrl = '/soft/atoms/japan/'
const AtomsJapanSeries: React.FC = () => {
  const { t, isJa } = useLocale()
  return (
    <Box>
      <Box p={2}>{`${t.SOFT_BALL_GLOVE_MITT} / ATOMS / ${t.POSITION_SELECTION_PAGE}`}</Box>
      <Box p={10}>
        <Card style={{ padding: '16px' }}>
          <Box>{t.GLOVE}</Box>
          <Box display={'flex'} justifyContent={'space-around'}>
            <Grid container>
              <Grid item>
                <Box p={1}>
                  <Linker href={`${baseUrl}pitcher`}>
                    <Button variant={'contained'} color={'primary'} size={'large'}>
                      {t.PITCHER}
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              <Grid item>
                <Box p={1}>
                  <Linker href={`${baseUrl}infielder`}>
                    <Button variant={'contained'} color={'primary'} size={'large'}>
                      {t.INFIELDER}
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              <Grid item>
                <Box p={1}>
                  <Linker href={`${baseUrl}outfielder`}>
                    <Button variant={'contained'} color={'primary'} size={'large'}>
                      {t.OUTFIELDER}
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              {isJa && (
                <Grid item>
                  <Box p={1}>
                    <Linker href={`${baseUrl}youth/glove`}>
                      <Button variant={'contained'} color={'primary'} size={'large'}>
                        YOUTHグラブ
                      </Button>
                    </Linker>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Card>
        <Box m={2} />
        <Card style={{ padding: '16px' }}>
          <Box p={0}>{t.MITT}</Box>
          <Box display={'flex'} justifyContent={'space-around'}>
            <Grid container>
              <Grid item>
                <Box p={1}>
                  <Linker href={`${baseUrl}catcher`}>
                    <Button variant={'contained'} color={'primary'} size={'large'}>
                      {t.CATCHER}
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              <Grid item>
                <Box p={1}>
                  <Linker href={`${baseUrl}first`}>
                    <Button variant={'contained'} color={'primary'} size={'large'}>
                      {t.FIRST_BASEMAN}
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              {isJa && (
                <Grid item>
                  <Box p={1}>
                    <Linker href={`${baseUrl}youth/mitt`}>
                      <Button variant={'contained'} color={'primary'} size={'large'}>
                        YOUTHミット
                      </Button>
                    </Linker>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Card>
      </Box>
    </Box>
  )
}

export default AtomsJapanSeries
